import React from 'react';
import MMOnboardingWizard from './MMOnboardingWizard';
import axios from 'axios';

interface Props {
  currentUser: any;
  onModule: (module: string) => void;
  onLogout: () => void;
  expiredAccounts: string[];
  modules: string[];
}

export default function Home({ currentUser, onModule, onLogout, expiredAccounts, modules: allowedModules }: Props) {
  const [mmOnbClosed, setMmOnbClosed] = React.useState(false);
  // Kreator pokazuje sie gdy firma NIE ma konta Allegro (a nie wg flagi onboarding_done).
  // null = jeszcze nie wiadomo (odpowiedz nie przyszla) — wtedy NIE pokazujemy (brak mrugania).
  const [hasAllegro, setHasAllegro] = React.useState<boolean | null>(null);
  React.useEffect(() => {
    let alive = true;
    axios.get('/api/allegro/accounts')
      .then(r => { if (alive) setHasAllegro(Array.isArray(r.data) && r.data.length > 0); })
      .catch(() => { if (alive) setHasAllegro(null); }); // blad -> nie pokazuj (bezpiecznik)
    return () => { alive = false; };
  }, []);
  const showMMOnb = hasAllegro === false && !mmOnbClosed; // kreator dla KAZDEJ firmy bez Allegro (zawieszone i tak nie loguja sie)
  const allModules = [
    {
      id: 'messages',
      icon: '✉️',
      title: 'Kontakt',
      desc: 'Wiadomości, dyskusje i reklamacje, oceny oraz skrzynki e-mail',
      color: '#1d4ed8',
      bg: '#eff6ff',
      border: '#bfdbfe',
    },
    {
      id: 'offers',
      icon: '🏪',
      title: 'Oferty',
      desc: 'Zarządzanie ofertami, ceny, stany, przedsprzedaż, wyróżnienia',
      color: '#15803d',
      bg: '#f0fdf4',
      border: '#bbf7d0',
    },
    {
      id: 'returns',
      icon: '📦',
      title: 'Zwroty',
      desc: 'Przesyłki zwrotne od klientów — obsługa zwrotów towarów i reklamacji Allegro',
      color: '#d97706',
      bg: '#fffbeb',
      border: '#fde68a',
    },
    {
      id: 'refund-claims',
      icon: '💰',
      title: 'Odrzucone',
      desc: 'Wnioski o zwrot prowizji — odwołania, weryfikacja',
      color: '#b91c1c',
      bg: '#fff1f2',
      border: '#fecdd3',
    },

    {
      id: 'shipments',
      icon: '🚚',
      title: 'Przesyłki',
      desc: 'Przesyłki wysłane do klientów — znajdź zamówienie po numerze przesyłki, sprawdź status i śledzenie',
      color: '#0f766e',
      bg: '#f0fdfa',
      border: '#99f6e4',
    },
    {
      id: 'orders',
      icon: '🛒',
      title: 'Zamówienia',
      desc: 'Zamówienia Allegro — statusy, kolory oznaczeń, notatki, historia i synchronizacja',
      color: '#c2410c',
      bg: '#fff7ed',
      border: '#fdba74',
    },
    {
      id: 'aiopen',
      icon: '🤖',
      title: 'AI OPEN',
      desc: 'Asystent sprzedaży do Twojego sklepu www, znajdzie produkt, doradzi, przyjmie zamówienie.',
      color: '#7c3aed',
      bg: '#faf5ff',
      border: '#ddd6fe',
    },
    {
      id: 'apilo',
      icon: '🔍',
      title: 'Apilo',
      desc: 'Wyszukiwarka zamowien Apilo — po nazwisku, telefonie, numerze, miescie',
      color: '#0369a1',
      bg: '#f0f9ff',
      border: '#bae6fd',
    },
    {
      id: 'settings',
      icon: '⚙️',
      title: 'Ustawienia',
      desc: 'Konta Allegro, AI, baza wiedzy, auto-odpowiedzi',
      color: '#6b7280',
      bg: '#f9fafb',
      border: '#e5e7eb',
    },

  ];
  const modules = allModules.filter(m => {
    if (m.id === 'settings' && currentUser?.role === 'admin') return true;
    if (m.id === 'aiopen') return true;  // widoczny zawsze; dostep sprawdzany przy wejsciu
    if (m.id === 'apilo') return true;  // widoczny zawsze dla wszystkich; podlaczenie sprawdzane w module
    if (m.id === 'shipments') return allowedModules.includes('messages');
    if (m.id === 'refund-claims') return allowedModules.includes('issues');
    if (m.id === 'returns') return allowedModules.includes('messages') || allowedModules.includes('returns');
    return allowedModules.includes(m.id);
  });

  return (
    <>
    {showMMOnb && <MMOnboardingWizard isMobile={typeof window !== 'undefined' && window.innerWidth < 768} onDone={() => setMmOnbClosed(true)} />}
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'system-ui, sans-serif', color: '#111827' }}>
      {/* Naglowek */}
      <div style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '14px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontSize: 22 }}>✉️</span>
          <div>
            <div style={{ fontWeight: 700, fontSize: 17, color: '#111827' }}>OPENkontakt</div>
            <div style={{ fontSize: 11, color: '#9ca3af' }}>Panel zarzadzania</div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ textAlign: 'right' as const }}>
            <div style={{ fontSize: 13, fontWeight: 500, color: '#374151' }}>{currentUser?.name || currentUser?.email}</div>
            <div style={{ fontSize: 11, color: '#9ca3af' }}>{currentUser?.role}</div>
          </div>

          <button onClick={onLogout} style={{ border: '1px solid #d1d5db', borderRadius: 6, padding: '6px 12px', fontSize: 12, cursor: 'pointer', background: '#fff', color: '#6b7280' }}>
            Wyloguj
          </button>
        </div>
      </div>

      {/* Alert wygaslych kont */}
      {expiredAccounts.length > 0 && (
        <div style={{ background: '#fef2f2', borderBottom: '1px solid #fecaca', padding: '10px 24px', display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 14 }}>⚠️</span>
          <span style={{ fontSize: 13, color: '#dc2626', fontWeight: 500 }}>
            Wygasle polaczenie Allegro: {expiredAccounts.join(', ')} — przejdz do Ustawien aby odswiezyc.
          </span>
          <button onClick={() => onModule('settings')} style={{ marginLeft: 8, fontSize: 12, color: '#dc2626', background: 'none', border: '1px solid #fca5a5', borderRadius: 4, padding: '2px 8px', cursor: 'pointer' }}>
            Ustawienia
          </button>
        </div>
      )}

      {/* Moduly */}
      <div style={{ maxWidth: 900, margin: '32px auto', padding: '0 16px' }}>
        <div style={{ textAlign: 'center' as const, marginBottom: 48 }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#111827', marginBottom: 8 }}>Witaj, {currentUser?.name || 'Administratorze'}</div>
          <div style={{ fontSize: 15, color: '#9ca3af' }}>Wybierz modul aby zaczac prace</div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16 }}>
          {modules.map(m => (
            <button key={m.id} onClick={() => onModule(m.id)}
              style={{ background: m.bg, border: '2px solid ' + m.border, borderRadius: 16, padding: '32px 24px', cursor: 'pointer', textAlign: 'left' as const, transition: 'transform 0.1s', display: 'block', width: '100%' }}
              onMouseEnter={e => (e.currentTarget.style.transform = 'translateY(-2px)')}
              onMouseLeave={e => (e.currentTarget.style.transform = 'translateY(0)')}>
              <div style={{ fontSize: 40, marginBottom: 16 }}>{m.icon}</div>
              <div style={{ fontSize: 18, fontWeight: 700, color: m.color, marginBottom: 8 }}>{m.title}</div>
              <div style={{ fontSize: 13, color: '#9ca3af', lineHeight: 1.5 }}>{m.desc}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
    </>
  );
}
